// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDy8WpH4Gi1mLdOc4B6u_VXo4EFMck0MRk",
    authDomain: "quize-app-76706.firebaseapp.com",
    projectId: "quize-app-76706",
    storageBucket: "quize-app-76706.appspot.com",
    messagingSenderId: "778366520220",
    appId: "1:778366520220:web:2d1b4ed5be7edbcbcad659",
    measurementId: "G-K557S0EYT4",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
